/* New Hogg-owned file (Theme Modernization, CLAUDE-THEMES.md "Quick Add
   Modal Content Gaps"). Simplifies the itg_vertical custom Flickity
   gallery (snippets/product-media-gallery-custom.liquid) specifically
   when it's shown inside a collection-page "Choose options" Quick Add
   modal: hides the thumbnail rail/arrows (handled in CSS, see
   assets/section-collection-grid-custom.css) and shows exactly one
   image at a time, swapping to the selected variant's image via Dawn's
   own PUB_SUB_EVENTS.variantChange (published by product-info.js, which
   loads inside the modal since its <script> tag lives inside
   <product-info>'s boundary in sections/main-product.liquid).

   Does not touch quick-add.js, product-media-gallery-custom.liquid, or
   Flickity -- those stay byte-identical to stock/CONTROL-restored.
   Only reachable code path is products using gallery_layout:
   "thumbnail_slider itg_vertical"; on any other gallery layout the
   selectors below simply match nothing (safe no-op). */

document.addEventListener('DOMContentLoaded', function () {
  var ACTIVE_CLASS = 'quick-add-gallery-active';

  function activateCell(cell) {
    if (!cell) return;
    var slider = cell.closest('.product__image-slider');
    if (!slider) return;
    slider.querySelectorAll('.carousel-cell.' + ACTIVE_CLASS).forEach(function (el) {
      el.classList.remove(ACTIVE_CLASS);
    });
    cell.classList.add(ACTIVE_CLASS);
  }

  function promoteLazyImage(mediaEl) {
    if (!mediaEl || mediaEl.tagName !== 'IMG') return;
    if (mediaEl.hasAttribute('data-flickity-lazyload-src')) {
      mediaEl.src = mediaEl.getAttribute('data-flickity-lazyload-src');
    }
    if (mediaEl.hasAttribute('data-flickity-lazyload-srcset')) {
      mediaEl.srcset = mediaEl.getAttribute('data-flickity-lazyload-srcset');
    }
  }

  // Initial state: once a modal's content is injected, activate whichever
  // cell rendered first -- product-media-gallery-custom.liquid always
  // renders the selected/first-available variant's own media first, with
  // a real (non-lazy) src already, so no promotion is needed here.
  document.querySelectorAll('.quick-add-modal__content-info').forEach(function (container) {
    new MutationObserver(function () {
      var slider = container.querySelector('.product__image-slider');
      if (!slider || slider.querySelector('.carousel-cell.' + ACTIVE_CLASS)) return;
      activateCell(slider.querySelector('.carousel-cell'));
    }).observe(container, { childList: true });
  });

  // Variant change while a modal is open. Originally filtered by
  // checking for a "quickadd-" prefix on event.data.sectionId, based on
  // quick-add.js's preventDuplicatedIDs() renaming the live data-section
  // attribute -- wrong assumption, found live 2026-08-24: product-info.js
  // publishes sectionId via `this.dataset.originalSection ||
  // this.dataset.section`, and preventDuplicatedIDs() sets
  // dataset.originalSection to the *un-renamed* original id specifically,
  // so the prefix never actually appears and every event was silently
  // dropped. Fixed by not matching on sectionId at all -- a quick-add
  // modal is the only source of this event on the collection page, so
  // just check whether one is currently open (ModalDialog.show() sets
  // the `open` attribute on <quick-add-modal>, confirmed in global.js)
  // and use its own container directly.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var openModal = document.querySelector('.quick-add-modal[open]');
      if (!openModal) return;

      var container = openModal.querySelector('.quick-add-modal__content-info');
      if (!container) return;

      var variant = event && event.data && event.data.variant;
      var mediaId = variant && variant.featured_media && variant.featured_media.id;
      if (!mediaId) return;

      var targetEl = container.querySelector('.product__image-slider [data-media-id="' + mediaId + '"]');
      if (!targetEl) return;

      promoteLazyImage(targetEl);
      activateCell(targetEl.closest('.carousel-cell'));
    });
  }
});
